module.exports = "/_next/static/images/58966717ca7eba1e9a2aff7f3275ec0d-rewards-app-lg@2x.png.webp";